<template>
	<div id="dataswipertitle">
		<h2 :class="fulltitle?'title dataswipertitle':'pagetitle title' " @mouseover="drawer = true">
			<!-- 
			<span v-if="userdata.countyText !=''">{{userdata.countyText}}</span> -->
			<span>{{bigtitle}}</span>{{title}}<i class="el-icon-arrow-down dataswipertitle_icon"></i>
		</h2>
		<div class="Drawerbox1" @click="drawer= false" v-show="drawer">
			<div class="Drawer1" @mouseleave="drawer = false">
					<dl>
					<dt class="dtitle">综合发展：</dt>
					<dd>
						<span :class="{'Drawer_li':true,'D-current':navcode == 'HGSJ'}" @click="routerself('/hongguanshuju-saas')">{{titlecity1}}宏观数据监测</span>
						<span :class="{'Drawer_li':true,'D-current':navcode == 'DDJJFZ'}"  @click="routerself('/dangdijingjifazhan-saas')" v-show="userdata.countyText !='' && userdata.countyText!='东营经济技术开发区'">{{userdata.countyText}}当地经济发展</span>
						<span :class="{'Drawer_li':true,'D-current':navcode == 'JZL'}" @click="routerself('/jingzhengli-saas')"   v-show="!isprovince">{{titlecity}}竞争力数字大屏</span>
						</dd> 
						</dl>  
					<dl>
						<dt class="dtitle">招商环境：</dt> 
						<dd>
						<span :class="{'Drawer_li':true,'D-current':navcode == 'ZSDDT'}" @click="routerself('/zhaoshangditu-saas')">{{titlecity}}{{userdata.countyText}}招商大地图</span>
						<span :class="{'Drawer_li':true,'D-current':navcode == 'ZSHJ'}" @click="routerself('/zhaoshanghuanjing2-saas')">{{titlecity}}招商环境</span>
						<span :class="{'Drawer_li':true,'D-current':navcode == 'ZSXM'}" @click="routerself('/zhaoshangxiangmu-saas')">{{titlecity}}招商项目</span>
						<!-- <span :class="{'Drawer_li':true,'D-current':navcode == 'ZSTP'}" @click="routerself('/zhaoshangtupu-saas')">{{titlecity}}{{userdata.countyText}}招商图谱</span> -->
						</dd>
					</dl>   
					<dl>
						<dt class="dtitle">产业发展：</dt> 
						<dd>
						<!-- <span :class="{'Drawer_li':true,'D-current':navcode == 'CYFZ'}"	@click="routerself('/chanyefazhan-saas')">{{titlecity}}{{userdata.countyText}}产业发展</span> -->
						<span :class="{'Drawer_li':true,'D-current':navcode == 'CYYD'}" @click="routerself('/chanyeyongdi-saas')">{{titlecity}}{{userdata.countyText}}产业用地</span> 
						<span :class="{'Drawer_li':true,'D-current':navcode == 'QYSJ'}" @click="routerself('/qiyeshuju-saas')">{{titlecity}}{{userdata.countyText}}企业数据</span>
					</dd>
					</dl> 
					<video-teaching :type="4" style="margin-left:140px;"></video-teaching>
			</div>  
		</div>
	</div> 
</template>

<script>
import { indexOf } from 'core-js/library/fn/array';
import { List } from 'echarts/lib/export';
	export default {
		name: 'daswiperNav',
		data() {
			return {
				 name:"招商大屏菜单栏",userdata:{},drawer:false,isprovince:false,titlecity:'',titlecity1:"",bigtitle:"",
					
					list1:['宏观数据监测','当地经济发展','竞争力数字大屏','招商大地图','招商环境','招商项目','招商图谱','产业发展','产业用地','企业数据'],
					titlelist:[
						{code:"ZHFZ",title:"综合发展",chidren:[
							{code:"HGSJJC",title:"宏观数据监测"},
							{code:"DDJJFZ",title:"当地经济发展"},
							{code:"JZLSZDP",title:"竞争力数字大屏"},
						]},
						{code:"ZSHJ",title:"招商环境",chidren:[
							{code:"ZSDDT",title:"招商大地图"},
							{code:"ZSHJ",title:"招商环境"},
							{code:"ZSXM",title:"招商项目"},
							{code:"ZSTP",title:"招商图谱"},
						]},
						{code:"CYFZ",title:"产业发展",chidren:[
						{code:"CYFZ",title:"产业发展"},
						{code:"CYYD",title:"产业用地"},
						{code:"QYSJ",title:"企业数据"},
						]},
						
					],
		}},
		props: { 
			indexnum: Number, 
			title:String,
			fulltitle:Boolean,
			navcode:{type:String,require:true},
			// drawer1:Boolean,
		},  
			// watch:{
			// 	drawer1:{
			// 		handler(newValue,oldValue){ 
			// 			this.type=newValue; 
			// 			// console.log('123123',$('.nav_li').eq(this.curindex).siblings('.nav_li'))
						 
			// 		}  
			// 	}, 
			// },
			mounted() {
				this.userdata=this.getuserinformain();
				// for(var i=0;i<this.list1.length;i++){
				// 	if(this.title.indexOf(this.list1[i])>-1 ){
				// 			document.getElementsByClassName('Drawer_li')[i].className="Drawer_li D-current";
				// 	}
				// }
				// if(this.indexnum){
				// 	var indexnums=this.indexnum-1;
				// 	console.log(indexnums)
				// 	document.getElementsByClassName('Drawer_li')[indexnums].className="Drawer_li D-current";
				// }
				this.isprovince=this.userdata.userAbbr.length>0 && this.userdata.provinceText.indexOf(this.userdata.userAbbr)>-1; 
				this.titlecity=this.userdata.currentCity.text;
				if(this.userdata.currentCity.type == "county"){
						this.titlecity1=this.userdata.cityText;
				}else{
					this.titlecity1=this.titlecity;
				} 
			this.bigtitle=(this.title.indexOf('宏观数据')>-1 && this.userdata.currentCity.type == "county") ? this.userdata.cityText : this.titlecity;
				
				
			}   
			
	}
</script>

<style>
	.Drawerbox1{
		left:0;
	}
	#dataswipertitle>.title{
		font-size: 36px; 
		text-align: center; 
		letter-spacing: 2px;
		margin-bottom: 10px;
		cursor: pointer;
	}
	/* .dataswipertitle1{
		color: #59ccc2;   line-height: 108px;
	} */
</style>